const CDN_BASE_URL = 'https://anewgocdn.us'

export const gcsURL = (folder, file) => {
  return `${CDN_BASE_URL}/${folder}/${file}`
}
